import { Component, OnInit } from '@angular/core';
import { RoutesService } from 'src/app/services/routes.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.html',
  styleUrls: ['./not-found.scss']
})
export class NotFoundPage implements OnInit {
  public url: string;
  
  constructor(private routeService: RoutesService) { }

  ngOnInit(): void {
    this.url = this.routeService.getCurrentPath();
  }

}
